export default __webpack_public_path__ + "static/media/love-youGirl.f2a7249e.webp";